import { render, staticRenderFns } from "./C2wCampaignsReports.vue?vue&type=template&id=2c29b54f&scoped=true&"
import script from "./C2wCampaignsReports.vue?vue&type=script&lang=js&"
export * from "./C2wCampaignsReports.vue?vue&type=script&lang=js&"
import style0 from "./C2wCampaignsReports.vue?vue&type=style&index=0&id=2c29b54f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c29b54f",
  null
  
)

export default component.exports